/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page_head"
};
const _hoisted_2 = {
  class: "max_item_box"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  key: 0,
  class: "btn_box"
};
const _hoisted_6 = ["src", "onClick"];
const _hoisted_7 = ["src", "onClick"];
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 4
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  key: 0,
  class: "btn_box"
};
const _hoisted_18 = ["src", "onClick"];
const _hoisted_19 = ["src", "onClick"];
const _hoisted_20 = ["src", "onClick"];
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  key: 2
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 3
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  key: 4
};
import leftTree from "@/components/leftTree/index.vue";
import { reactive } from "vue";
import { queryEvaluationTarget, addEvaluationTarget, editEvaluationTarget, deleteEvaluationTarget } from "@/api";
import { treeLoadValue, box } from "@sunrise";
import { ElMessage, ElMessageBox } from "element-plus";
import { filter } from "lodash";
export default {
  __name: 'evaluationProjectSettings',
  setup(__props) {
    const leftTreeData = ref([]);
    let dfsDataList = [];
    const tree_c = ref(null);
    const getLeftData = async targetCode => {
      const {
        code,
        data
      } = await queryEvaluationTarget();
      if (code == "success") {
        leftTreeData.value = treeLoadValue(JSON.parse(JSON.stringify(data))).map(i => {
          i.type = "A";
          return i;
        });
        dfsDataList = treeLoadValue(data, "flat");
        if (!!params.item) {
          loadTableVal();
          tree_c.value.resize();
        }
      }
    };
    getLeftData();
    const params = reactive({});
    const tableData = ref([]);
    const header = [{
      label: "类别名称",
      prop: "targetName",
      width: 100
    }, {
      label: "项目名称",
      prop: "evaluationTargetListInfoVoList",
      minWidth: 180
      // showOverflowTooltip: true,
    }, {
      label: "项目描述",
      prop: "remark",
      minWidth: 250,
      align: "left"
    },
    // {
    //   label: "达标占比（%）",
    //   prop: "zb",
    //   width: 120,
    // },
    {
      label: "是否基础指标",
      prop: "istargetTypejc",
      width: 110,
      isHelp: true
    }, {
      label: "操作",
      prop: "",
      width: 100
    }];
    const headerTypeA = [{
      label: "类别名称",
      prop: "parentCode",
      width: 130
    }, {
      label: "项目名称",
      prop: "targetName",
      minWidth: 180
      // showOverflowTooltip: true,
    }, {
      label: "项目描述",
      prop: "remark",
      minWidth: 250,
      align: "left"
    }, {
      label: "是否基础指标",
      prop: "targetType",
      width: 110,
      isHelp: true
    }, {
      label: "操作",
      prop: "",
      width: 100
    }];
    const options = ref([]);
    const loadTableVal = () => {
      if (isTypeA.value) {
        const parentItem = params.item.evaluationTargetListInfoVoList.map(i => ({
          targetCode: i.targetCode,
          targetName: i.targetName
        }));
        options.value = parentItem;
        tableData.value = JSON.parse(JSON.stringify(dfsDataList)).filter(i => parentItem.map(s => s.targetCode).includes(i.parentCode)).map(i => {
          i.isEdit = false;
          try {
            i.remarkText = JSON.parse(i.remark);
            i.remark = JSON.parse(i.remark).map((o, oIndex) => {
              return oIndex + 1 + "." + o;
            }).join("");
          } catch (error) {
            i.remark;
            i.remarkText = i.remark.split("。").map((i, index, arrs) => {
              if (index != arrs.length - 1) {
                const strArr = i.split("");
                strArr.push("。");
                return strArr.join("");
              }
              return i;
            });
          }
          return i;
        });
        return;
      }
      const item = JSON.parse(JSON.stringify(dfsDataList)).find(i => i.targetCode == params.item.targetCode);
      tableData.value = item?.evaluationTargetListInfoVoList.length ? item?.evaluationTargetListInfoVoList?.map(i => {
        i.isEdit = false;
        try {
          i.remarkText = JSON.parse(i.remark);
          i.remark = JSON.parse(i.remark).map((o, oIndex) => {
            return oIndex + 1 + "." + o;
          }).join("");
        } catch (error) {
          i.remark;
          i.remarkText = i.remark.split("。").map((i, index, arrs) => {
            if (index != arrs.length - 1) {
              const strArr = i.split("");
              strArr.push("。");
              return strArr.join("");
            }
            return i;
          });
        }
        i.evaluationTargetListInfoVoList = i.targetName;
        i.targetName = item.targetName;
        i.istargetTypejc = i.targetType;
        return i;
      }) : [];
    };
    const isTypeA = ref(false);
    const isAdd = ref(false);
    const event = reactive({
      nodeClick(data, node) {
        isAdd.value = node.level == 2;
        if (params.item?.targetCode != data.targetCode) {
          params.item = data;
          isTypeA.value = data?.type == "A";
          loadTableVal();
        }
      }
    });
    const addTarget = () => {
      if (!params?.item) {
        ElMessage.warning("请选择您要添加的类别！");
        return;
      }
      for (const item of tableData.value) {
        if (item.isEdit) {
          ElMessage.warning("请先保存！");
          return;
        }
      }
      if (isTypeA.value) {
        tableData.value.push({
          targetName: "",
          parentCode: options.value[0].targetCode,
          isEdit: true
        });
        return;
      }
      tableData.value.push({
        targetName: params.item.targetName,
        parentCode: params.item.parentCode,
        isEdit: true
      });
    };
    const submitAdd = async row => {
      if (isTypeA.value) {
        if (!!inEditValue.value) {
          const {
            code,
            data
          } = await editEvaluationTarget(row);
          if (code == "success") {
            ElMessage.success("编辑成功！");
            getLeftData();
            inEditValue.value = null;
          }
          return;
        }
        const {
          code,
          data
        } = await addEvaluationTarget(row);
        if (code == "success") {
          ElMessage.success("新增成功！");
          getLeftData();
        }
        return;
      }
      if (!!inEditValue.value) {
        const params = {
          id: row.id,
          targetName: row.evaluationTargetListInfoVoList,
          targetType: row.istargetTypejc,
          parentCode: row.parentCode,
          remark: row.remark
        };
        const {
          code,
          data
        } = await editEvaluationTarget(params);
        if (code == "success") {
          ElMessage.success("编辑成功！");
          getLeftData();
          inEditValue.value = null;
        }
        return;
      }
      const {
        code,
        data
      } = await addEvaluationTarget({
        targetName: row.evaluationTargetListInfoVoList,
        targetType: row.istargetTypejc,
        parentCode: params.item.targetCode,
        remark: row.remark
      });
      if (code == "success") {
        ElMessage.success("新增成功！");
        getLeftData();
      }
    };
    const inEditValue = ref("");
    const editFn = row => {
      row.isEdit = true;
      inEditValue.value = row;
    };
    const deleteItem = row => {
      box("你确定删除此条评价项目吗？", async () => {
        if (!!row.id) {
          const {
            code
          } = await deleteEvaluationTarget({
            id: row.id
          });
          if (code == "success") {
            ElMessage.success("删除成功！");
            inEditValue.value = null;
            getLeftData();
          }
        } else {
          tableData.value = tableData.value.filter(i => !Object.is(i, row));
          inEditValue.value = null;
          ElMessage.success("删除成功！");
        }
      }, "警告");
    };
    let ids = [];
    let items = [];
    const selectTable = select => {
      ids = select.filter(i => !!i.id);
      items = select.filter(i => !i.id);
    };
    const deleteItems = () => {
      box("你确定删除这些评价项目吗？", async () => {
        // dfsDataList
        if (ids.length) {
          const {
            code
          } = await deleteEvaluationTarget({
            id: ids.map(i => i.id).join(",")
          });
          if (code == "success") {
            await getLeftData();
            ElMessage.success("删除成功！");
            inEditValue.value = null;
            dfsDataList = dfsDataList.filter(i => !ids.map(s => s.id).includes(i.id));
          }
        } else {
          tableData.value = tableData.value.filter(i => {
            for (const iterator of items) {
              return !Object.is(iterator, i);
            }
          });
          inEditValue.value = null;
          ElMessage.success("删除成功！");
        }
      }, "警告");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_head_title = _resolveComponent("head-title");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_head_title, {
        title: "评价项目设置"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "danger",
          onClick: deleteItems
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("批量删除", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addTarget,
          disabled: !_unref(isAdd)
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("新增", -1)]))]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(leftTree, _mergeProps({
        ref_key: "tree_c",
        ref: tree_c
      }, {
        att: {
          data: _unref(leftTreeData),
          currentNodeKey: params?.item?.targetCode
        },
        event: event
      }), null, 16)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
        data: _unref(tableData),
        style: {
          "width": "100%",
          "height": "100%"
        },
        stripe: "",
        onSelectionChange: selectTable
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection"
        }), _unref(isTypeA) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(headerTypeA, (v, i) => {
          return _createVNode(_component_el_table_column, _mergeProps({
            key: 'A' + i,
            align: "center"
          }, {
            ref_for: true
          }, v), {
            header: _withCtx(() => [_createElementVNode("div", _mergeProps({
              ref_for: true
            }, v), _toDisplayString(v.label), 17)]),
            default: _withCtx(({
              row,
              $index
            }) => [v.prop == '' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [!_unref(isTypeA) ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [!row.isEdit ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              title: "编辑",
              src: require('@/assets/images/evaluationRule/edit.png'),
              alt: "",
              onClick: $event => editFn(row)
            }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              title: "保存",
              src: require('@/assets/images/evaluationRule/submit.png'),
              alt: "",
              onClick: $event => submitAdd(row)
            }, null, 8, _hoisted_7))], 64)) : _createCommentVNode("", true), _createElementVNode("img", {
              title: "删除",
              src: require('@/assets/images/evaluationRule/delete.png'),
              alt: "",
              onClick: $event => deleteItem(row)
            }, null, 8, _hoisted_8)])) : ['targetName'].includes(v.prop) ? (_openBlock(), _createElementBlock("span", _hoisted_9, [row.isEdit ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: '请输入' + v.label,
              type: "textarea",
              rows: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row[v.prop]), 1))])) : ['remark'].includes(v.prop) ? (_openBlock(), _createElementBlock("span", _hoisted_11, [row.isEdit ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: '请输入' + v.label,
              type: "textarea",
              rows: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createElementBlock("span", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.remarkText, (v, keys) => {
              return _openBlock(), _createElementBlock("div", {
                key: keys
              }, _toDisplayString(keys + 1 + "." + v), 1);
            }), 128))]))])) : v.prop == 'targetType' ? (_openBlock(), _createElementBlock("span", _hoisted_13, [row.isEdit ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                label: '是',
                value: 2
              }, {
                label: '否',
                value: 1
              }], (v, i) => {
                return _createVNode(_component_el_option, {
                  key: v.value,
                  label: v.label,
                  value: v.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.targetType == 2 ? "是" : "否"), 1))])) : v.prop == 'parentCode' ? (_openBlock(), _createElementBlock("span", _hoisted_15, [row.isEdit ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: "请选择类别名称"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.targetCode,
                  label: item.targetName,
                  value: item.targetCode
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(options).find(i => i.targetCode == row[v.prop]).targetName), 1))])) : _createCommentVNode("", true)]),
            _: 2
          }, 1040);
        }), 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(header, (v, i) => {
          return _createVNode(_component_el_table_column, _mergeProps({
            key: i,
            align: "center"
          }, {
            ref_for: true
          }, v), {
            header: _withCtx(() => [_createElementVNode("div", _mergeProps({
              ref_for: true
            }, v), _toDisplayString(v.label), 17)]),
            default: _withCtx(({
              row,
              $index
            }) => [v.prop == '' ? (_openBlock(), _createElementBlock("span", _hoisted_17, [!row.isEdit ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              title: "编辑",
              src: require('@/assets/images/evaluationRule/edit.png'),
              alt: "",
              onClick: $event => editFn(row)
            }, null, 8, _hoisted_18)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              title: "保存",
              src: require('@/assets/images/evaluationRule/submit.png'),
              alt: "",
              onClick: $event => submitAdd(row)
            }, null, 8, _hoisted_19)), _createElementVNode("img", {
              title: "删除",
              src: require('@/assets/images/evaluationRule/delete.png'),
              alt: "",
              onClick: $event => deleteItem(row)
            }, null, 8, _hoisted_20)])) : ['evaluationTargetListInfoVoList'].includes(v.prop) ? (_openBlock(), _createElementBlock("span", _hoisted_21, [row.isEdit ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: '请输入' + v.label,
              type: "textarea",
              rows: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row[v.prop]), 1))])) : ['remark'].includes(v.prop) ? (_openBlock(), _createElementBlock("span", _hoisted_23, [row.isEdit ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event,
              placeholder: '请输入' + v.label,
              type: "textarea",
              rows: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : (_openBlock(), _createElementBlock("span", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.remarkText, (v, i) => {
              return _openBlock(), _createElementBlock("div", {
                key: i
              }, _toDisplayString(i + 1 + "." + v), 1);
            }), 128))]))])) : v.prop == 'istargetTypejc' ? (_openBlock(), _createElementBlock("span", _hoisted_25, [row.isEdit ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: row[v.prop],
              "onUpdate:modelValue": $event => row[v.prop] = $event
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
                label: '是',
                value: 2
              }, {
                label: '否',
                value: 1
              }], (v, i) => {
                return _createVNode(_component_el_option, {
                  key: v.value,
                  label: v.label,
                  value: v.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.targetType == 2 ? "是" : "否"), 1))])) : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row[v.prop]), 1))]),
            _: 2
          }, 1040);
        }), 64))]),
        _: 1
      }, 8, ["data"])])])]);
    };
  }
};